"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.array.find");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

require("core-js/modules/es6.function.name");

var _axisLabelFormatterOptions = _interopRequireDefault(require("../label-formatters/axis-label-formatter-options"));

var _coerce = _interopRequireDefault(require("@meltwater/coerce"));

var _fillSeriesColor = _interopRequireDefault(require("../fill-series-color"));

var _axisLabelFormatters = require("../label-formatters/axis-label-formatters");

var _highcharts = _interopRequireDefault(require("highcharts"));

var _legendClickHandlers = require("../legend-click-handlers");

var _logger = _interopRequireDefault(require("../logger"));

var _mwChartNSeriesLineOptions = _interopRequireDefault(require("./mw-chart-n-series-line-options/"));

var _mwChartNSeriesLineTooltipOptions = _interopRequireDefault(require("./mw-chart-n-series-line-tooltip-options"));

var _chartingBackend = require("../charting-backend");

var _nSeriesPointClickOptions = _interopRequireDefault(require("../n-series-point-click-options"));

var _seriesData = _interopRequireDefault(require("../series-data"));

var _tooltipFormatters = require("../tooltip-formatters");

var _chartOptions = require("../chart-options");

var _styles = require("../styles");

var _selectedPoint = _interopRequireDefault(require("../selected-point"));

var ACCUMULATE_SELECTED_POINTS = true;
var DATA_POINT_BORDER_COLOR = '#ffffff';
var MAX_SERIES_COUNT = 10;

function createSeriesOptions(chartData, hiddenSeriesIndices, seriesColors) {
  var selectedPoints = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  return chartData.map(function (series, index) {
    var isSeriesVisible = !hiddenSeriesIndices.some(function (seriesIndex) {
      return seriesIndex === index;
    });
    return {
      name: series.name,
      color: seriesColors[index],
      type: 'spline',
      data: series.data.map(function (point, pointIndex) {
        return {
          /* eslint-disable id-length */
          y: point,
          x: pointIndex,

          /* eslint-enable id-length */
          selected: selectedPoints.some(function (point) {
            return point.seriesIndex === index && point.key === pointIndex;
          })
        };
      }),
      marker: {
        states: {
          select: {
            fillColor: seriesColors[index],
            lineColor: "".concat(seriesColors[index], "80")
          }
        }
      },
      visible: isSeriesVisible
    };
  });
}
/**
 * A class for rendering a line chart with n series of data
 */


var MwChartNSeriesLine =
/*#__PURE__*/
function () {
  /**
   * Create a new N Series Line Chart
   * @param {string|HTMLElement} renderTarget - The id of, or the HTMLElement for, the element to render into. Note: this element will be emptied!
   */
  function MwChartNSeriesLine(renderTarget) {
    (0, _classCallCheck2.default)(this, MwChartNSeriesLine);

    if (!renderTarget) {
      throw new TypeError('renderTarget is required.');
    }

    this.__chart = null;
    this.__renderTarget = renderTarget;
  }
  /**
   * Set the chart data to be rendered
   * @param {SeriesData} chartData - The data to be rendered to the chart
   * @returns {undefined}
   */


  (0, _createClass2.default)(MwChartNSeriesLine, [{
    key: "setChartData",
    value: function setChartData(chartData) {
      if (!Array.isArray(chartData)) {
        throw new TypeError("chartData must be an Array! Provided value: ".concat(JSON.stringify(chartData)));
      }

      if (chartData.length > MAX_SERIES_COUNT) {
        throw new Error("Array length of chartData must be less or equal than 10. Provided array length: ".concat(chartData.length));
      }

      this.__chartData = chartData.map(function (data) {
        return (0, _coerce.default)(data, _seriesData.default, "chartData should be shaped like a SeriesData. Provided value: ".concat(JSON.stringify(chartData)));
      });
    }
    /**
     * Set the visualization options for the chart
     * @param {MwChartNSeriesChartOptions} changedChartOptions - The visualization options for the chart
     * @returns {undefined}
     */

  }, {
    key: "setChartOptions",
    value: function setChartOptions(changedChartOptions) {
      var onError = changedChartOptions.onError;

      if (typeof onError !== 'function') {
        onError = function onError() {};
      }

      var onPointClick = changedChartOptions.onPointClick;

      if (typeof onPointClick !== 'function') {
        onPointClick = undefined;
      }

      var chartOptions = Object.assign({}, changedChartOptions, {
        onError: onError,
        onPointClick: onPointClick
      });
      this.__chartOptions = (0, _coerce.default)(chartOptions, _mwChartNSeriesLineOptions.default, "chartOptions must be a valid MwChartNSeriesChartOptions object. Provided value: ".concat(JSON.stringify(chartOptions)));
    }
    /**
     * Render the chart to the renderTarget passed in the constructor
     * @returns {undefined}
     */

  }, {
    key: "render",
    value: function render() {
      var _this = this;

      try {
        this.error = false;
        var highchartData = (0, _chartingBackend.nSeriesChartDataToHighchartsData)(this.__chartData);
        var categories = highchartData.categories;
        var series = highchartData.series;
        var safeHighchartOptions = this.__chartOptions;
        var seriesColors = (0, _fillSeriesColor.default)(safeHighchartOptions.seriesColors, series.length);
        var seriesOptions = createSeriesOptions(series, safeHighchartOptions.hiddenSeriesIndices, seriesColors, safeHighchartOptions.selectedPoints);

        if (!this.__renderTarget) {
          throw new Error('Parent container needs to have a non zero "offsetHeight" property');
        }

        var LEGEND_CURSOR_STYLE = _styles.CURSOR_DEFAULT;

        if (safeHighchartOptions.onLegendClick) {
          LEGEND_CURSOR_STYLE = _styles.CURSOR_POINTER;
        }

        var onLegendClickCallback = (0, _legendClickHandlers.legendClickResolver)({
          chart: this,
          chartData: this.__chartData,
          chartOptions: this.__chartOptions,
          onLegendClick: safeHighchartOptions.onLegendClick
        });
        var onPointClickCallback;

        if (safeHighchartOptions.onPointClick) {
          onPointClickCallback = function onPointClickCallback(clickEvent) {
            var options = new _nSeriesPointClickOptions.default(clickEvent);
            return safeHighchartOptions.onPointClick(options);
          };
        }

        var resolvedXAxisLabelFormatter;

        if (typeof safeHighchartOptions.xAxisLabelFormatter === 'string') {
          resolvedXAxisLabelFormatter = (0, _axisLabelFormatters.getFormatter)(safeHighchartOptions.xAxisLabelFormatter);
        } else {
          resolvedXAxisLabelFormatter = safeHighchartOptions.xAxisLabelFormatter;
        }

        var safeXAxisLabelFormatter = function safeXAxisLabelFormatter() {
          var options = new _axisLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            isFirst: this.isFirst,
            isLast: this.isLast,
            value: this.value
            /* eslint-enable no-invalid-this */

          });
          return resolvedXAxisLabelFormatter(options);
        };

        var resolvedYAxisLabelFormatter;

        if (typeof safeHighchartOptions.yAxisLabelFormatter === 'string') {
          resolvedYAxisLabelFormatter = (0, _axisLabelFormatters.getFormatter)(safeHighchartOptions.yAxisLabelFormatter);
        } else {
          resolvedYAxisLabelFormatter = safeHighchartOptions.yAxisLabelFormatter;
        }

        var safeYAxisLabelFormatter = function safeYAxisLabelFormatter() {
          var options = new _axisLabelFormatterOptions.default({
            /* eslint-disable no-invalid-this */
            isFirst: this.isFirst,
            isLast: this.isLast,
            value: this.value
            /* eslint-enable no-invalid-this */

          });
          return resolvedYAxisLabelFormatter(options);
        };

        var safeTooltipFormatter;
        var enableTooltip = false;

        if (safeHighchartOptions.tooltipFormatter) {
          var tooltipFormatter = safeHighchartOptions.tooltipFormatter;

          if ((0, _tooltipFormatters.isValidTooltipFormatter)(tooltipFormatter)) {
            var tooltipFormatterFactory = (0, _tooltipFormatters.getFactory)(tooltipFormatter);
            tooltipFormatter = tooltipFormatterFactory({
              options: this.__chartOptions,
              series: this.__chartData
            });
          }

          enableTooltip = true;

          var currentHiddenSeriesIndices = function currentHiddenSeriesIndices() {
            return _this.__chartOptions.hiddenSeriesIndices;
          };

          safeTooltipFormatter = function safeTooltipFormatter() {
            /* eslint-disable no-invalid-this */
            var options = new _mwChartNSeriesLineTooltipOptions.default({
              hiddenSeriesIndices: currentHiddenSeriesIndices(),
              point: this.point,
              series: this.series
            });
            /* eslint-enable no-invalid-this */

            return tooltipFormatter(options);
          };
        }

        var safeDataLabelFormatter;

        if (safeHighchartOptions.dataLabelFormatter) {
          safeDataLabelFormatter = function safeDataLabelFormatter() {
            /* eslint-disable no-invalid-this */
            var value = this.y;
            /* eslint-enable no-invalid-this */

            return safeHighchartOptions.dataLabelFormatter(value);
          };
        }

        this.__chart = _highcharts.default.chart(this.__renderTarget, {
          title: {
            text: ''
          },
          chart: {
            renderTo: this.__renderTarget,
            reflow: false,
            style: {
              fontFamily: _styles.FONT_FAMILY,
              color: _styles.AXIS_LABEL_FONT_COLOR
            }
          },
          credits: {
            enabled: false
          },
          exporting: {
            enabled: false
          },
          legend: {
            enabled: !safeHighchartOptions.hideLegend,
            symbolWidth: 8,
            itemStyle: {
              color: _styles.LEGEND_LABEL_FONT_COLOR,
              cursor: LEGEND_CURSOR_STYLE,
              fontFamily: _styles.FONT_FAMILY,
              fontSize: _styles.LEGEND_LABEL_FONT_SIZE,
              fontWeight: _styles.LEGEND_LABEL_FONT_WEIGHT
            },
            itemHoverStyle: {
              color: _styles.LEGEND_LABEL_FONT_COLOR
            }
          },
          xAxis: {
            categories: categories,
            crosshair: {
              color: _styles.LINE_AND_TICK_COLOR,
              width: 1
            },
            gridLineWidth: 0,
            labels: {
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR
              },
              step: safeHighchartOptions.xAxisLabelStep,
              formatter: safeXAxisLabelFormatter
            },
            lineColor: _styles.LINE_AND_TICK_COLOR,
            lineWidth: 1,
            tickColor: _styles.LINE_AND_TICK_COLOR,
            tickmarkPlacement: _chartOptions.TICKMARK_PLACEMENT,
            tickLength: safeHighchartOptions.xAxisTickLength,
            tickWidth: safeHighchartOptions.xAxisTickWidth
          },
          yAxis: {
            labels: {
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR,
                fontFamily: _styles.FONT_FAMILY,
                fontWeight: _styles.AXIS_LABEL_FONT_WEIGHT
              },
              formatter: safeYAxisLabelFormatter
            },
            title: {
              text: safeHighchartOptions.yAxisTitleText,
              style: {
                color: _styles.AXIS_LABEL_FONT_COLOR,
                fontFamily: _styles.FONT_FAMILY,
                fontWeight: _styles.AXIS_LABEL_FONT_WEIGHT
              }
            },
            tickWidth: 1,
            tickLength: 4,
            tickColor: _styles.LINE_AND_TICK_COLOR,
            lineWidth: 1,
            lineColor: _styles.LINE_AND_TICK_COLOR,
            gridLineWidth: 0
          },
          tooltip: {
            enabled: enableTooltip,
            useHTML: true,
            formatter: safeTooltipFormatter
          },
          plotOptions: {
            series: {
              animation: safeHighchartOptions.animate,
              cursor: 'pointer',
              dataLabels: {
                enabled: safeHighchartOptions.areDataLabelsVisible,
                formatter: safeDataLabelFormatter,
                style: {
                  fontFamily: _styles.FONT_FAMILY,
                  fontWeight: _styles.POINT_LABEL_FONT_WEIGHT,
                  color: _styles.AXIS_LABEL_FONT_COLOR
                }
              },
              events: {
                click: onPointClickCallback,
                legendItemClick: onLegendClickCallback
              },
              marker: {
                enabled: null,
                symbol: 'circle',
                radius: 5,
                states: {
                  select: {
                    radius: _styles.MARKER_SERIES_SELECT_RADIUS,
                    lineWidth: _styles.MARKER_SERIES_SELECT_LINE_WIDTH,
                    lineColor: _styles.MARKER_SERIES_SELECT_LINE_COLOR
                  }
                },
                lineColor: DATA_POINT_BORDER_COLOR,
                lineWidth: 2
              },
              states: {
                hover: {
                  halo: {
                    size: 12
                  }
                }
              }
            }
          },
          series: seriesOptions
        });
      } catch (error) {
        this.error = true;

        _logger.default.error('Chart failed to render.', error);

        this.__chartOptions.onError(error);
      }
    }
    /**
     *  Update which series are currently hidden
     *
     * @param {number[]} hiddenSeriesIndices - The indices of the series to be hidden
     *
     * @returns {undefined}
     */

  }, {
    key: "updateHiddenSeriesIndices",
    value: function updateHiddenSeriesIndices(hiddenSeriesIndices) {
      (0, _chartingBackend.updateHiddenSeriesIndices)({
        chart: this,
        chartData: this.__chartData,
        chartInstance: this.__chart,
        chartOptions: this.__chartOptions,
        hiddenSeriesIndices: hiddenSeriesIndices
      });
    }
    /**
     * Update the points that are currently selected on the chart
     *
     * @param {SelectedPoint[]} selectedPoints - An array of points that should be currently selected
     *
     *  @returns {undefined}
     */

  }, {
    key: "updateSelectedPoints",
    value: function updateSelectedPoints(selectedPoints) {
      var _this2 = this;

      try {
        this.error = false;

        if (this.__chart === null) {
          throw new Error('The chart must have been successfully rendered before it can be updated.');
        }

        var safeSelectedPoints = selectedPoints.map(function (selectedPoint) {
          return (0, _coerce.default)(selectedPoint, _selectedPoint.default, "selectedPoints must be an array of items coercable to SelectedPoint. Provided value: ".concat(JSON.stringify(selectedPoints)));
        });
        var selectedPointsMap = {};
        safeSelectedPoints.forEach(function (selectedPoint) {
          selectedPointsMap[selectedPoint.serialize()] = selectedPoint;
        });
        var updatedKeys = Object.keys(selectedPointsMap);
        var existingKeys = Object.keys(this.__chartOptions.selectedPointsMap);
        var addedKeys = updatedKeys.filter(function (key) {
          return !existingKeys.includes(key);
        });
        addedKeys.forEach(function (key) {
          var selectedPoint = selectedPointsMap[key];

          var chartPoint = _this2.__chart.series[selectedPoint.seriesIndex].data.find(function (point) {
            return point.x === selectedPoint.key;
          });

          chartPoint.select(true, ACCUMULATE_SELECTED_POINTS);
        });
        var removedKeys = existingKeys.filter(function (key) {
          return !updatedKeys.includes(key);
        });
        removedKeys.forEach(function (key) {
          var selectedPoint = _this2.__chartOptions.selectedPointsMap[key];

          var chartPoint = _this2.__chart.series[selectedPoint.seriesIndex].data.find(function (point) {
            return point.x === selectedPoint.key;
          });

          chartPoint.select(false, ACCUMULATE_SELECTED_POINTS);
        });
        this.setChartOptions(Object.assign({}, this.__chartOptions, {
          selectedPoints: safeSelectedPoints
        }));
      } catch (error) {
        this.error = true;

        _logger.default.error('Chart failed to render.', error);

        this.__chartOptions.onError(error);
      }
    }
  }]);
  return MwChartNSeriesLine;
}();

exports.default = MwChartNSeriesLine;